import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
    Badge,
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    FormGroup,
    Input,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Table,
} from "reactstrap";
import {
    DELETE_RP_ALARM,
    DELETE_RP_SUMMARY_ALARM,
    GET_RP_ALARM,
    GET_RP_SUMMARY_ALARM,
    SAVE_LIST_RP_ALARM,
    SAVE_LIST_RP_SUMMARY_ALARM,
    SAVE_RP_ALARM,
    SAVE_RP_SUMMARY_ALARM
} from "../../../helpers/url_api_constant";
import MessageDialog, {
    useModalShowMessage,
} from "../../../components/Custom/MessageDialog";
import React, { useEffect, useState } from "react";
import { post, postUpload } from "../../../helpers/api_helper";

import OverButton from "../../../components/Custom/Overbutton";
import PieChart from "../../SummaryReport/SectionAlarm/PieChart";
import PropTypes from "prop-types";
import moment from "moment";
import { useDispatch } from "react-redux";

function SectionAlarm(props) {
    function numberFormat(number, digit = 2) {
        if (number === null || number === "null" || number === "") return "";
        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        }
        if (isFloat(number))
            return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
                minimumFractionDigits: digit,
            });
        return parseFloat(number).toLocaleString(undefined, {
            minimumFractionDigits: digit,
        });
    }
    // console.log(props);
    const dispatch = useDispatch();
    // const [searchDate, setSearchDate] = useState(moment(new Date().setDate(new Date().getDate() - 1)).format(
    //     "YYYY-MM-DD"));
    const searchDate = { SUMMARYREPORT_PID: props.summaryReportPid, SELECT_DATE: props.date };

    const [listAlarmMedium, setListAlarmMedium] = useState([]);
    const [listAlarmUrgent, setListAlarmUrgent] = useState([]);

    const [totalSummary, setTotalSummary] = useState({ ALARM_MEDIUM: 0, ALARM_URGENT: 0, ALARM_NORMAL: 0, ALARM_EVENT: 0 });

    const [totalMedium, setTotalMedium] = useState(null);
    const [totalUrgent, setTotalUrgent] = useState(null);


    useEffect(function () {
        fetchData();
    }, [props.summaryReportPid]);

    const compare = (a, b) => {
        // console.log(a, b);
        if (a.TOTAL > b.TOTAL) {
            return -1;
        }
        if (a.TOTAL < b.TOTAL) {
            return 1;
        }
        return 0;
    }

    const fetchData = async () => {
        let sumMedium = 0;
        let sumUrgent = 0;

        dispatch(loadingAction.showLoading());
        // console.log(searchDate);
        try {
            let res = await post(GET_RP_ALARM, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682" });
            let summary = await post(GET_RP_SUMMARY_ALARM, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682" });
            // console.log(res);
            // console.log(summary);
            if (res.data.rpAlarmList != null) {

                let ListTotalAlarmMedium = res.data.rpAlarmList.sort(compare).filter((obj) => obj.ALARM_TYPE == "MEDIUM");
                let ListTotalAlarmUrgent = res.data.rpAlarmList.sort(compare).filter((obj) => obj.ALARM_TYPE != "MEDIUM");

                setListAlarmMedium(
                    ListTotalAlarmMedium
                );

                setListAlarmUrgent(
                    ListTotalAlarmUrgent
                );

                if (summary.data.rpAlarmSummaryList.length == 1) {
                    setTotalSummary(summary.data.rpAlarmSummaryList[0]);
                };

                // for (let i = 0; i < ListTotalAlarmMedium.length; i++) {
                //     sumMedium += ListTotalAlarmMedium[i].TOTAL;
                // }

                // for (let i = 0; i < ListTotalAlarmUrgent.length; i++) {
                //     sumUrgent += ListTotalAlarmUrgent[i].TOTAL;
                // }
                // setTotalUrgent(
                //     sumMedium
                // );
                // setTotalMedium(
                //     sumUrgent
                // );

            } else {
                setListAlarmMedium([]);
                setListAlarmUrgent([]);
                setTotalSummary({});

                // setTotalMedium(null);
                // setTotalUrgent(null);

            }

        } catch (err) {
            dispatch(messageAction.showMessage(err.message));
        }
        dispatch(loadingAction.hideLoading());
    };



    function RenderListAlarmMedium(prop) {
        // console.log(prop);
        return (
            <tr>
                <td className="text-center">{prop.indexlist}</td>
                <td className="text-center">{prop.data.TAG_NAME}</td>
                <td className="text-center">{prop.data.TAG_DESC}</td>
                <td className="text-center">{prop.data.TOTAL}</td>
                <td className="text-center">{prop.data.USER_GROUP}</td>
                {/* <td className="text-center">{prop.data.REGION_CODE}</td> */}
                <td className="text-center">{prop.data.STATE}</td>
                <td className="text-center">{prop.data.RTU_CODE}</td>
                {/* <td className="text-center">{prop.data.DASHBOARD_DESC}</td> */}
                <td className="text-center">
                    <Input
                        type="textarea"
                        rows="2"
                        readOnly
                        className="form-control"
                        value={prop.data.DASHBOARD_DESC}
                    />
                </td>
            </tr>
        );
    }

    function RenderListAlarmUrgent(prop) {
        // console.log(prop);
        return (
            <tr>
                <td className="text-center">{prop.indexlist}</td>
                <td className="text-center">{prop.data.TAG_NAME}</td>
                <td className="text-center">{prop.data.TAG_DESC}</td>
                <td className="text-center">{prop.data.TOTAL}</td>
                <td className="text-center">{prop.data.USER_GROUP}</td>
                {/* <td className="text-center">{prop.data.REGION_CODE}</td> */}
                <td className="text-center">{prop.data.STATE}</td>
                <td className="text-center">{prop.data.RTU_CODE}</td>
                {/* <td className="text-center">{prop.data.DASHBOARD_DESC}</td> */}
                <td className="text-center">
                    <Input
                        type="textarea"
                        rows="2"
                        readOnly
                        className="form-control"
                        value={prop.data.DASHBOARD_DESC}
                    />
                </td>
            </tr>
        );
    }

    return (
        <Row>
            <Col sm="12">
                <Card className="mb-1" style={{ backgroundColor: "#001fff1f" }}>
                    <CardBody>
                        <Row>
                            <Col sm="12">
                                <Row className="mt-0">
                                    <Col sm="12">
                                        <h5 className="mb-0 sm-0 font-size-18" style={{ color: "#2FA3FF" }}> Alarm Management </h5>
                                    </Col>
                                </Row>

                                <Row className="mt-2">
                                    <hr style={{ color: "#2FA3FF" }} />
                                </Row>

                                <Row className="mt-0">
                                    <Col lg="6" className="mt-0">
                                        <div>
                                            {/* className="table-responsive" */}
                                            {/* hover-table-highlight */}
                                            <Table className="table table-bordered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th colSpan={8} style={{ backgroundColor: "#556ee64a", color: "#FFFFFF", textAlign: "left", width: "100%", fontSize: "20px" }}>Realtime Alarm Info</th>
                                                    </tr>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#556ee678", color: "#FFFFFF", textAlign: "center", width: "20%" }}>Alarm</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "20%" }}>Total</th>
                                                        <th style={{ backgroundColor: "#5868b785", color: "#FFFFFF", textAlign: "center", width: "20%" }}>Percent(%)</th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                                                    <tr style={{color:"#FF4545"}}>
                                                        <td>Urgent</td>
                                                        <td>{numberFormat(totalSummary.ALARM_URGENT, 0)}</td>
                                                        <td>{numberFormat(((totalSummary.ALARM_URGENT * 100) / (totalSummary.ALARM_MEDIUM + totalSummary.ALARM_URGENT +
                                                            totalSummary.ALARM_EVENT + totalSummary.ALARM_NORMAL)), 2)} %</td>

                                                        {/* <td>{totalUrgent}</td>
                                                        <td>{((totalUrgent * 100) / (totalMedium + totalUrgent)).toFixed(2)} %</td> */}

                                                    </tr>
                                                    <tr style={{color:"#DE7332"}}>
                                                        <td>Medium</td>
                                                        <td>{numberFormat(totalSummary.ALARM_MEDIUM, 0)}</td>
                                                        <td>{numberFormat(((totalSummary.ALARM_MEDIUM * 100) / (totalSummary.ALARM_MEDIUM + totalSummary.ALARM_URGENT +
                                                            totalSummary.ALARM_EVENT + totalSummary.ALARM_NORMAL)), 2)} %</td>

                                                        {/* <td>{totalMedium}</td>
                                                        <td>{((totalMedium * 100) / (totalMedium + totalUrgent)).toFixed(2)} %</td> */}
                                                    </tr>
                                                    <tr style={{color:"#DBFE6C"}}>
                                                        <td>Normal</td>
                                                        <td>{numberFormat(totalSummary.ALARM_NORMAL, 0)}</td>
                                                        <td>{numberFormat(((totalSummary.ALARM_NORMAL * 100) / (totalSummary.ALARM_MEDIUM + totalSummary.ALARM_URGENT +
                                                            totalSummary.ALARM_EVENT + totalSummary.ALARM_NORMAL)), 2)} %</td>

                                                        {/* <td>{totalUrgent}</td>
                                                        <td>{((totalUrgent * 100) / (totalMedium + totalUrgent)).toFixed(2)} %</td> */}
                                                    </tr>
                                                    <tr style={{color:"#5DE7FD"}}>
                                                        <td>Event</td>
                                                        <td>{numberFormat(totalSummary.ALARM_EVENT, 0)}</td>
                                                        <td>{numberFormat(((totalSummary.ALARM_EVENT * 100) / (totalSummary.ALARM_MEDIUM + totalSummary.ALARM_URGENT +
                                                            totalSummary.ALARM_EVENT + totalSummary.ALARM_NORMAL)), 2)} %</td>
                                                        {/* <td>{totalUrgent}</td>
                                                        <td>{((totalUrgent * 100) / (totalMedium + totalUrgent)).toFixed(2)} %</td> */}
                                                    </tr>
                                                    <tr style={{ backgroundColor: "#556ee64a" }}>
                                                        <td>Summary</td>
                                                        <td>{numberFormat(totalSummary.ALARM_MEDIUM + totalSummary.ALARM_URGENT + totalSummary.ALARM_EVENT + totalSummary.ALARM_NORMAL, 0)}</td>
                                                        <td>100 %</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Col>
                                    {/* <Col lg="1">

                                    </Col> */}
                                    <Col lg="6">
                                        {/* <CardTitle className="mb-4 h4" style={{color:"#3F91FF"}}>Realtime Alarm Info</CardTitle> */}
                                        <div id="pie-chart" className="e-chart">
                                            {/* <Alarm date = {searchModel.Date} /> */}

                                            <PieChart dataAlarmMedium={totalSummary.ALARM_MEDIUM} dataAlarmUrgent={totalSummary.ALARM_URGENT} dataAlarmNormal={totalSummary.ALARM_NORMAL} dataAlarmEvent={totalSummary.ALARM_EVENT} />
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="mt-0">
                                    <Col lg="12">
                                        <div>
                                            {/* className="table-responsive" */}
                                            {/* hover-table-highlight */}
                                            <Table className="table table-bordered mb-0">
                                                <thead>
                                                    <tr>
                                                        {/* สีเดิม ff000073 */}
                                                        <th colSpan={8} style={{ backgroundColor: "#ff00008c", color: "#FFFFFF", textAlign: "left", width: "100%", fontSize: "20px" }}>Top Urgent Alarm</th>
                                                    </tr>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", textAlign: "center", width: "3%" }}>No.</th>
                                                        <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", textAlign: "center", width: "15%" }}>Tag Name</th>
                                                        <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", textAlign: "center", width: "20%" }}>Description</th>
                                                        <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", textAlign: "center", width: "8%" }}>Count</th>
                                                        <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", textAlign: "center", width: "8%" }}>User</th>
                                                        {/* <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", textAlign: "center", width: "8%" }}>Region</th> */}
                                                        <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", textAlign: "center", width: "8%" }}>State</th>
                                                        <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", textAlign: "center", width: "8%" }}>RTU Code</th>
                                                        <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", textAlign: "center", width: "30%" }}>Cause</th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>

                                                    {listAlarmUrgent.map((value, index) => (<RenderListAlarmUrgent key={index} data={value} indexlist={index + 1} />))}

                                                </tbody>
                                            </Table>
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col lg="12">
                                        <div>
                                            {/* className="table-responsive" */}
                                            {/* hover-table-highlight */}
                                            <Table className="table table-bordered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th colSpan={8} style={{ backgroundColor: "#ff5b1994", color: "#FFFFFF", textAlign: "left", width: "100%", fontSize: "20px" }}>Top Medium Alarm</th>
                                                    </tr>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#ff5b1959", color: "rgba(215,172,108,1)", textAlign: "center", width: "3%" }}>No.</th>
                                                        <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", textAlign: "center", width: "15%" }}>Tag Name</th>
                                                        <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", textAlign: "center", width: "20%" }}>Description</th>
                                                        <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", textAlign: "center", width: "8%" }}>Count</th>
                                                        <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", textAlign: "center", width: "8%" }}>User</th>
                                                        {/* <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", textAlign: "center", width: "8%" }}>Region</th> */}
                                                        <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", textAlign: "center", width: "8%" }}>State</th>
                                                        <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", textAlign: "center", width: "8%" }}>RTU Code</th>
                                                        <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", textAlign: "center", width: "30%" }}>Cause</th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                                                    {listAlarmMedium.map((value, index) => (<RenderListAlarmMedium key={index} data={value} indexlist={index + 1} />))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}

SectionAlarm.propTypes = {
    t: PropTypes.any,
    date: PropTypes.any,
    summaryReportPid: PropTypes.any,
}

export default SectionAlarm
